<template>
  <van-form @submit="submit">
    <van-field
      required
      v-model="FUserIDNo"
      name="FUserIDNo"
      label="身份证号码"
      placeholder="点击查询按钮可查询历史记录"
      :rules="[{ pattern:patternID, error: '请输入正确身份证' }]"
      format-trigger="onBlur"
    >
      <template #button>
        <van-button size="small" type="primary" @click="qHistory(FUserIDNo)" native-type="button">查询</van-button>
      </template>
    </van-field>
    <van-field
      required
      v-model="FUserName"
      name="FUserName"
      label="预约人"
      placeholder="请填写预约人姓名"
      :rules="[{ required: true, error: '请填写预约人姓名' }]"
    />
    <van-field
      required
      v-model="FPhoneNo"
      name="FPhoneNo"
      label="预约人电话"
      placeholder="请输入正确电话格式"
      :rules="[{ pattern, error: '请输入正确电话格式' }]"
    />
    <van-field
      required
      v-model="FCompany"
      name="FCompany"
      label="预约人公司"
      placeholder="请填写预约人公司"
      :rules="[{ required: true, error: '请填写预约人公司' }]"
    />
    <van-field name="checkDrive" label="是否驾车">
      <template #input>
        <van-checkbox v-model="checkDrive" shape="square" @click="dirveClick"/>
      </template>
    </van-field>
    <van-field
      v-show="carShow"
      v-model="FCarNum"
      name="FCarNum"
      label="车牌号码"
      placeholder="请填写车牌号码"
    />
    <van-field
      required
      v-model="FRPhoneNo"
      name="FRPhoneNo"
      label="接待人电话"
      placeholder="接待人电话"
      :rules="[{ pattern, error: '请输入正确电话格式' }]"
      :formatter="formatterRPN"
      format-trigger="onBlur"
    />
    <van-field
      v-model="FRUserName"
      name="FRUserName"
      label="接待人"
      placeholder="接待人姓名"
      readonly
    />
    <van-field
      clickable
      name="FDeptName"
      :value="value1"
      label="接待部门"
      placeholder="接待部门"
      readonly
    />
    <!--    <van-popup v-model="showPicker" position="bottom">-->
    <!--      <van-picker-->
    <!--        show-toolbar-->
    <!--        :columns="FDeptName"-->
    <!--        @confirm="onConfirm"-->
    <!--        @cancel="showPicker = false"-->
    <!--      />-->
    <!--    </van-popup>-->
    <van-field
      required
      readonly
      clickable
      name="Date"
      :value="value2"
      label="到访日期"
      placeholder="点击选择日期"
      @click="showCalendar = true"
      :rules="[{ required: true, error: '请选择日期' }]"
    />
    <van-calendar v-model="showCalendar" @confirm="onConfirmDate"/>
    <van-field
      required
      readonly
      clickable
      name="Time"
      :value="value3"
      label="时间选择"
      placeholder="点击选择时间"
      @click="showPickerTime = true"
      :rules="[{ required: true, error: '请选择时间' }]"
    />
    <van-popup v-model="showPickerTime" position="bottom">
      <van-datetime-picker
        type="time"
        @confirm="onConfirmTime"
        @cancel="showPickerTime = false"
      />
    </van-popup>
    <van-field
      required
      readonly
      clickable
      name="FAdress"
      :value="value5"
      label="入厂地址"
      placeholder="点击选择入厂地址"
      @click="showPickerAd = true"
      :rules="[{ required: true, error: '请选择入厂地址' }]"
    />
    <van-popup v-model="showPickerAd" position="bottom">
      <van-picker
        show-toolbar
        :columns="FAdress"
        @confirm="onConfirmAd"
        @cancel="showPickerAd = false"
      />
    </van-popup>
    <van-field
      required
      readonly
      clickable
      name="FVType"
      :value="value4"
      label="访问类型"
      placeholder="点击选择访问类型"
      @click="showPickerV = true"
      :rules="[{ required: true, error: '请选择访问类型' }]"
    />
    <van-popup v-model="showPickerV" position="bottom">
      <van-picker
        show-toolbar
        :columns="FVType"
        @confirm="onConfirmV"
        @cancel="showPickerV = false"
      />
    </van-popup>
    <van-field
      required
      v-model="FMemo"
      name="FMemo"
      label="事由"
      placeholder="事由"
      type="textarea"
      rows="2"
      :rules="[{ required: true, error: '请填写事由' }]"
    />
    <!--    添加随行人员-->
    <domT @arr-counter="getDomT"/>
<!--    疫情防控相关-->
<!--    <HealthCode @HContent="getHCode" />-->
<!--    <van-field v-if="switchStatus=='1'" name="switch" label="是否为省外来员">-->
<!--      <template #input>-->
<!--        <van-switch v-model="switchChecked" size="20" @input="switchCheck" ref="xx"/>-->
<!--      </template>-->
<!--    </van-field>-->
<!--    &lt;!&ndash;    疫情防控信息填报&ndash;&gt;-->
<!--    <COVID v-if="COVIDStatus=='1'" :COVIDList="COVIDList"/>-->

    <div style="margin: 16px;">
      <van-button round block type="info" native-type="submit">
        提交
      </van-button>
    </div>

  </van-form>


</template>

<script>
  import {Dialog} from 'vant'
  import {Toast} from 'vant'
  import domT from './domT'
  import COVID from './COVID'
  import HealthCode from './HealthCode'

  export default {
    name: 'formList',
    data () {
      return {
        FUserName: '',
        FRUserName: '',
        FCompany: '',
        FUserIDNo: '',
        FDeptName: '',
        FPhoneNo: '',
        FRPhoneNo: this.$route.params.phone ? this.$route.params.phone:'',
        pattern: /^[1][3,4,5,7,8,9][0-9]{9}$/,
        patternID: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
        FVType: ['供应商', '客户', '访客'],
        FAdress: ['研发大楼南门(隐珠山路1817号)','工厂南门(隐珠山路1817号)', '工厂北门(胶州湾西路1736号)', '智能产业园(凤凰山路4208号)','公寓(泰发路1555号)'],
        FDate: '',
        FConfirmTime: '',
        FMemo: '',
        value1: '',
        value2: this.getDate(),
        value3: '',
        value4: '',
        value5: '',
        showPickerV: false,
        showPickerAd: false,
        showPicker: false,
        showCalendar: false,
        showPickerTime: false,
        radio: '',

        COVIDStatus: '',
        switchChecked: false,
        switchStatus: '1',
        COVIDList: {},

        checkDrive: false,
        FCarNum: '',
        carShow: false,

        FSUserInfo: [],//随行人员信息,
        HContent:""//健康码
      }
    },
    components: {
      // COVID,
      domT,
      HealthCode
    },
    mounted () {
      // console.log(this.$route.params)
      // this.getDept()
      // let _this = this
      // if (_this.$route.params.phone) {
      //   _this.FRPhoneNo =_this.$route.params.phone
      // }

    },
    methods: {
      submit (values) {
        // if(this.HContent==""){
        //   Toast('请上传健康码截图')
        //   return
        // }
        Toast.loading({
          message: '提交中...',
          forbidClick: true,
        })

        const baseURL = this.GLOBAL.baseURL
        let _this = this

        var info = JSON.stringify(this.FSUserInfo)
        var cnt = this.FSUserInfo.length

        _this.$ajax
          .post(baseURL + 'visitors/insert_visitor', {
            FUserName: values.FUserName,
            FRUserName: values.FRUserName,
            FUserIDNo: values.FUserIDNo,
            FDeptName: values.FDeptName,
            FCompany: values.FCompany,
            FPhoneNo: values.FPhoneNo,
            FRPhoneNo: values.FRPhoneNo,
            FDate: values.Date + ' ' + values.Time + ':00',
            FVType: values.FVType,
            FAdress: values.FAdress,
            FMemo: values.FMemo,
            IsDrive: values.checkDrive,
            FCarNum: values.FCarNum,
            FFromArea: values.FFromArea,
            FCTime: values.FCTime,
            FTraffic: values.FTraffic,
            FTrafficXQ: values.FTrafficXQ,
            FXQArea: values.FXQArea,
            FFZUserName: values.FFZUserName,
            FFZPhone: values.FFZPhone,
            FRemark: values.FRemark,
            FZhenDuan: values.FZhenDuan,
            FJieChu: values.FJieChu,
            FConfirm: values.FConfirm,
            FSUserInfo: info,
            FSUserCnt: cnt,
            FPicture:_this.HContent.replace("data:image/jpeg;base64,","")
          })
          .then(response => {

            if (response.data.code == 0) {
              Toast.clear()
              if (response.data.outStatus == 1) {
                Dialog.alert({
                  message: response.data.outMsg,
                }).then(() => {
                  // on close
                })
              }
              _this.$router.push('./s/success')
            } else {
              Dialog.alert({
                message: response.data.msg,
              }).then(() => {
                // on close
              })
            }
          })

        // return;
        // _this.$ajax
        //   .get(baseURL + 'visitors/insert_visitor1', {
        //     params: {
        //       FUserName: values.FUserName,
        //       FRUserName: values.FRUserName,
        //       FUserIDNo: values.FUserIDNo,
        //       FDeptName: values.FDeptName,
        //       FCompany: values.FCompany,
        //       FPhoneNo: values.FPhoneNo,
        //       FRPhoneNo: values.FRPhoneNo,
        //       FDate: values.Date + ' ' + values.Time + ':00',
        //       FVType: values.FVType,
        //       FAdress: values.FAdress,
        //       FMemo: values.FMemo,
        //       IsDrive: values.checkDrive,
        //       FCarNum: values.FCarNum,
        //
        //       FFromArea: values.FFromArea,
        //       FCTime: values.FCTime,
        //       FTraffic: values.FTraffic,
        //       FTrafficXQ: values.FTrafficXQ,
        //       FXQArea: values.FXQArea,
        //       FFZUserName: values.FFZUserName,
        //       FFZPhone: values.FFZPhone,
        //       FRemark: values.FRemark,
        //       FZhenDuan: values.FZhenDuan,
        //       FJieChu: values.FJieChu,
        //       FConfirm: values.FConfirm,
        //       FSUserInfo:info,
        //       FSUserCnt: cnt
        //     },
        //     headers: {
        //       'Content-Type': 'application/x-www-form-urlencoded'
        //     }
        //   })
        //   .then(response => {
        //     if (response.data.code == 0) {
        //       if (response.data.outStatus == 1) {
        //         Dialog.alert({
        //           message: response.data.outMsg,
        //         }).then(() => {
        //           // on close
        //         })
        //       }
        //       _this.$router.push('./success')
        //     } else {
        //       Dialog.alert({
        //         message: response.data.msg,
        //       }).then(() => {
        //         // on close
        //       })
        //     }
        //   })
      },
      // send () {
      //   this.$refs.FormData.submit()
      // },
      onConfirm (value) {
        this.value1 = value
        this.showPicker = false
      },
      onConfirmDate (date) {
        this.value2 = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
        this.showCalendar = false
      },
      onConfirmTime (time) {
        this.value3 = time
        this.showPickerTime = false
      },
      onConfirmV (value) {
        this.value4 = value
        this.showPickerV = false
      },
      onConfirmAd (value) {
        this.value5 = value
        this.showPickerAd = false
      },
      showAdd (action, value) {
        this.show = true
      },
      chargeBtn (action, done) {
        if (action === 'confirm') {//取消按钮
          this.counter.push({})
          this.show = false
          done()
        }
      },
      getDept () {
        const baseURL = this.GLOBAL.baseURL
        let _this = this
        _this.$ajax
          .get(baseURL + 'visitors/select_dept')
          .then(response => {
            var arr = []
            var dept = ''
            for (var j in response.data) {
              dept += response.data[j].FDeptName + ','
            }
            _this.FDeptName = dept.substring(0, dept.length - 1).split(',')
          })
      },
      qHistory (value) {

        var IDCRules = value.substring(0, 2)
        if (IDCRules != '37' && IDCRules != '') {
          this.COVIDStatus = '1'
          this.switchStatus = '0'
        } else {
          this.COVIDStatus = '0'
          this.switchStatus = '1'
          this.switchChecked = false
        }
        // return value

        if (IDCRules != '') {
          Toast.loading({
            message: '查询中...',
            forbidClick: true,
          })
          const baseURL = this.GLOBAL.baseURL
          let _this = this
          _this.$ajax
            .get(baseURL + 'visitors/selectHistory', {
              params: {
                FUserIDNo: value,
              },
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
              }
            })
            .then(response => {
              if (response.data.code == 1) {
                Toast.clear()
                Toast(response.data.msg)
                return
              }
              _this.FUserIDNo = value
              var userinfo = response.data.data
              _this.FUserName = userinfo.FUserName
              _this.FPhoneNo = userinfo.FPhoneNo
              _this.FCompany = userinfo.FCompany
              if(!_this.$route.params.phone){
                _this.FRPhoneNo = userinfo.FRPhoneNo
                _this.FRUserName = userinfo.FRUserName
                _this.value1 = userinfo.FDeptName
              }
              _this.value5 = userinfo.FAdress
              _this.value4 = userinfo.FVType
              _this.FMemo = userinfo.FMemo

              if (userinfo.IsDrive == 'true' || userinfo.IsDrive == 1) {
                _this.carShow = true
                _this.checkDrive = true

              } else {
                _this.carShow = false
                _this.checkDrive = false
                _this.FCarNum = ''
              }
              _this.FCarNum = userinfo.FCarNum

              _this.COVIDList = {
                FFromArea: userinfo.FFromArea,
                FCTime: userinfo.FCTime,
                FTraffic: userinfo.FTraffic,
                FTrafficXQ: userinfo.FTrafficXQ,
                FXQArea: userinfo.FXQArea,
                FFZUserName: userinfo.FFZUserName,
                FFZPhone: userinfo.FFZPhone,
                FRemark: userinfo.FRemark,
                FZhenDuan: userinfo.FZhenDuan,
                FJieChu: userinfo.FJieChu,
                FConfirm: userinfo.FConfirm
              }
              Toast.clear()
            })

        }

      },
      switchCheck (value) {
        var s = value
        if (s == true) {
          this.COVIDStatus = '1'
        } else {
          this.COVIDStatus = '0'
        }
      },
      formatterRPN (value) {
        const baseURL = this.GLOBAL.baseURL
        let _this = this
        _this.$ajax
          .get(baseURL + 'visitors/select_DeptInfo', {
            params: {
              FPhoneNo: value,
            },
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          })
          .then(response => {
            this.FRPhoneNo = value
            if (response.data.code == '0') {
              this.FRPhoneNo = ''
              Dialog.alert({
                message: response.data.msg,
              }).then(() => {
                // on close
              })
            }

            _this.FRUserName = response.data.FUserName
            _this.value1 = response.data.FDeptName
          })
      },
      dirveClick () {
        this.carShow = !this.carShow
        if (this.carShow == false) {
          this.FCarNum = ''
        }
      },
      //获取domT的数据
      getDomT (data) {
        this.FSUserInfo = data
      },
      getHCode(data){
        this.HContent=data
      }
    }
  }
</script>
<style scoped>
  /*.btn-add {*/
  /*  background-color: #07c160;*/
  /*  color: #fff;*/
  /*  padding: 0 10px;*/
  /*  font-size: 14px;*/
  /*  height: 40px;*/
  /*  line-height: 2.8;*/
  /*  text-align: center;*/
  /*  border-radius: 2px;*/
  /*  cursor: pointer;*/
  /*  transition: opacity .2s;*/
  /*  -webkit-appearance: none;*/
  /*  width: 100px;*/
  /*  display: inline-block;*/
  /*}*/

  /*.btn-add:active {*/
  /*  background-color: #2E8B57;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/views/formList.vue